import getAll from './getAll'
import del from './delete'
import create from './create'
import get from './get'
import update from './update'
import getAllWithTags from './getAllWithTags'
import searchFor from "./searchFor";
import integrateToPlatform from "./integrateToPlatform";
import exportAll from './exportAll';
import removeTagFromPlaylist from './removeTagFromPlaylist';
import share from './share';
import createDemo from "./createDemo";
import getForClient from './getForClient';
import getAllForClient from './getAllForClient';
import getAllForSmartSearch from './getAllForSmartSearch';
import contact from "./contact";
import getCandidates from "./getCandidates";
import downloadMaterial from "./downloadMaterial";
import trackView from "../contentCreation/trackView"
import preview from "./preview"
import getHashcode from "./getHashcode"
import createForUser from "./createForUser"
import notify from "./notify"
import getPublic from "./getPublic"
import checkProfileUrl from './checkProfileUrl'
import setProfileUrl from './setProfileUrl'
import getPublicByAlias from './getPublicByAlias'
import showForHome from './showForHome'

export default host => ({
  getAll: getAll(host),
  delete: del(host),
  create: create(host),
  get: get(host),
  update: update(host),
  getAllWithTags: getAllWithTags(host),
  searchFor: searchFor(host),
  integrateToPlatform: integrateToPlatform(host),
  exportAll: exportAll(host),
  removeTagFromPlaylist: removeTagFromPlaylist(host),
  share: share(host),
  createDemo: createDemo(host),
  getForClient: getForClient(host),
  getAllForClient: getAllForClient(host),
  getAllForSmartSearch: getAllForSmartSearch(host),
  contact: contact(host),
  getCandidates: getCandidates(host),
  downloadMaterial: downloadMaterial(host),
  preview: preview(host),
  getHashcode: getHashcode(host),
  notify: notify(host),
  createForUser: createForUser(host),
  getPublic: getPublic(host),
  checkProfileUrl: checkProfileUrl(host),
  setProfileUrl: setProfileUrl(host),
  getPublicByAlias: getPublicByAlias(host),
  showForHome: showForHome(host)
})
